<div class="menu-container">
    <div class="header">
        <div>
            <h2>
                <button mat-icon-button (click)="back()">
                    <p>←</p>
                </button>
            </h2>
        </div>
        <div>
            <h3 i18n="@@order-complete_complete">Completed</h3>
        </div>
    </div>

    <div class="menu">
        <p i18n="@@order-complete_thank">Thank you for your order!</p>
        <p i18n="@@order-complete_email">You should receive an email confirmation with your details and PDF order form</p>
        <p i18n="@@order-complete_help">If you require any further assistance please let us know. We're here to help</p>
        <p i18n="@@order-complete_download" class="clickable" (click)="onDownloadQuote()">Click here to download a preview of your order</p>
    </div>
</div>
